import type { CreateQuoteLineInput } from "@/lib/api";
import {
  toDocumentLinePayload,
} from "@/features/document-lines/productDetails";
import type { DraftLine } from "@/features/document-lines/documentDraft";

export type QuoteLineDraft = DraftLine;

export { toMinor } from "@/features/document-lines/productDetails";

const QUOTE_STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  sent: "Sent",
  accepted: "Accepted",
  declined: "Declined",
  expired: "Expired",
  converted: "Converted",
};

export function quoteStatusLabel(status: string): string {
  return QUOTE_STATUS_LABELS[status.toLowerCase()] ?? status;
}

export function toQuoteLinePayload(
  lines: QuoteLineDraft[],
): CreateQuoteLineInput[] {
  if (lines.length === 0) throw new Error("Add at least one line.");
  return lines.map((line, index) => {
    return toDocumentLinePayload(line, index);
  });
}
